// src/store/slices/colorThemeSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { COLOR_PRESETS, generateColorPalette } from "../utils/colorUtils";

const initialState = {
	themeColorPalete: COLOR_PRESETS.tencolor1,
	selectedColorName: "tencolor1", // Removed TypeScript 'as' syntax
	customColorPalette: null,
};

const colorTheme = createSlice({
	name: "theme",
	initialState,
	reducers: {
		setColorTheme: (state, action) => {
			const selectedColor = action.payload;

			// Check if the color is one of our presets
			if (COLOR_PRESETS.hasOwnProperty(selectedColor)) {
				// It's a preset color
				state.themeColorPalete = COLOR_PRESETS[selectedColor];
				state.selectedColorName = selectedColor;
				state.customColorPalette = null;
			} else {
				// It's a custom color (hex value)
				const palette = generateColorPalette(selectedColor);
				state.themeColorPalete = palette;
				state.selectedColorName = "custom";
				state.customColorPalette = palette;
			}
		},
		// Accepts a full array of hex colors for the custom theme builder
		setCustomPalette: (state, action) => {
			const palette = action.payload; // string[]
			state.themeColorPalete = palette;
			state.selectedColorName = "custom";
			state.customColorPalette = palette;
		},
	},
});

export const { setColorTheme, setCustomPalette } = colorTheme.actions;
export default colorTheme.reducer;